// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-row {
  display: flex;
  margin-top: 20px;
}

.app-container {
  min-height: 40px;
}

.type-identifier {
  font-color: gray;
  display: flex;
  align-items: center;
}

.read-only .type-identifier {
  display: none;
}
.read-only .app-container {
  min-height: 0px;
}
.read-only .formteil-section {
  border: unset;
}

.formteil-section {
  padding-top: 2px;
  border-top: 1px solid lightgray;
}

.formteil-section .type-identifier-name {
  font-weight: bolder;
}

textarea, .after-dragger {
  width: 100%;
}

.para-line *, .root-line * {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 5px;
}

.formteil-line > div {
  margin: 10px;
  display: flex;
  align-items: center;
}
.formteil-line .deleteData {
  cursor: pointer;
  font-size: 0.83em;
  align-self: start;
}
.formteil-line .deleteData:hover {
  color: red;
}

.child {
  padding-left: 20px;
}

span.segment-type {
  cursor: pointer;
  border: 1px solid hsl(192, 100%, 80%);
  border-radius: 5px;
  padding: 3px;
}
span.segment-type:hover {
  background-color: hsl(192, 100%, 80%);
}

.form-control {
  margin: 5px;
}

.formteil-line-detail {
  margin-left: 30px;
}
.formteil-line-detail * {
  font-size: 0.9em;
}

.formteil-para-detail {
  margin-left: 5px;
}
.formteil-para-detail * {
  font-size: 0.9em;
}

.segment-type {
  font-weight: bolder;
}

.para-comment-button img {
  cursor: pointer;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown, .dropdown-toggle {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.dropdown-toggle:after {
  width: 100%;
  height: 100%;
  content: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/section/section.component.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AAFJ;;AAMC;EAAmB,aAAA;AAFpB;AAGC;EAAiB,eAAA;AAAlB;AACC;EAAoB,aAAA;AAErB;;AACA;EACI,gBAAA;EACA,+BAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;;AAEI;EAAI,eAAA;EACA,kBAAA;EACA,iBAAA;AAER;;AAII;EACH,YAAA;EACA,aAAA;EACA,mBAAA;AADD;AAII;EACH,eAAA;EACA,iBAAA;EACA,iBAAA;AAFD;AAGC;EACI,UAAA;AADL;;AAOA;EACI,kBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,qCAAA;EACA,kBAAA;EACA,YAAA;AAJJ;AAKI;EACH,qCAAA;AAHD;;AAOA;EACI,WAAA;AAJJ;;AAOA;EAEI,iBAAA;AALJ;AAII;EAAI,gBAAA;AADR;;AAKA;EACI,gBAAA;AAFJ;AAGI;EAAI,gBAAA;AAAR;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,wBAAA;AAAJ","sourcesContent":[".kind {\n}\n\n.content-row {\n    display: flex;\n    margin-top: 20px;\n}\n\n.app-container {\n    min-height: 40px;\n}\n\n.type-identifier {\n    font-color: gray;\n    display: flex;\n    align-items: center;\n}\n\n.read-only {\n\t.type-identifier { display: none; }\n\t.app-container { min-height: 0px; }\n\t.formteil-section { border: unset; }\n}\n\n.formteil-section {\n    padding-top: 2px;\n    border-top: 1px solid lightgray;\n}\n\n.formteil-section .type-identifier-name {\n    font-weight: bolder;\n}\n\ntextarea, .after-dragger {\n    width: 100%;\n}\n\n.para-line, .root-line {\n    * { margin-top: 5px;\n        margin-bottom: 5px;\n        margin-right: 5px;\n    }\n\n}\n\n.formteil-line {\n    >div {\n\tmargin: 10px;\n\tdisplay: flex;\n\talign-items: center;\n    }\n\n    .deleteData {\n\tcursor: pointer;\n\tfont-size: .83em;\n\talign-self: start;\n\t&:hover {\n\t    color: red;\n\t}\n    }\n}\n\n\n.child {\n    padding-left: 20px;\n}\n\nspan.segment-type {\n    cursor: pointer;\n    border: 1px solid hsl(192,100%,80);\n    border-radius: 5px;\n    padding: 3px;\n    &:hover {\n\tbackground-color: hsl(192, 100%, 80);\n    }\n}\n\n.form-control{\n    margin: 5px\n}\n\n.formteil-line-detail{\n    * { font-size: 0.9em; }\n    margin-left: 30px;\n}\n\n.formteil-para-detail {\n    margin-left: 5px;\n    * { font-size: 0.9em; }\n}\n\n.segment-type {\n    font-weight: bolder;\n}\n\n.para-comment-button img {\n    cursor: pointer;\n}\n\n.dropdown-item {\n    cursor: pointer;\n}\n\n.dropdown, .dropdown-toggle {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n}\n\n.dropdown-toggle:after {\n    width: 100%;\n    height: 100%;\n    content: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
